import { useEffect } from "react";
import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";
import insured from "../../../../assets/images/insured.svg";
import { withProps } from "recompose";
import { Flex, Box } from "@chakra-ui/react";
import moment from "moment";

const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 0 3em 3em;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 1em;
    text-align: center;
    flex-direction: column;
  }
  margin: 4em 0;
  display: flex;
  box-shadow: 0px 0px 19px -11px ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.white};
  border: 10px solid #29a737;
`;
const TextWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    line-height: 2.5em;
    padding: 0 4em 0 2em;
  }
`;
const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.5rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;
const Subtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 12pt;
  color: ${({ theme }) => theme.colors.secondary};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

const LogoWrapper = styled.div`
  align-self: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-self: auto;
    min-width: 9%;
  }
`;
const DataWrapper = styled.div`
  padding: 2em 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 0.5em;
    margin-bottom: 1em;
  }
`;
const BackButton = styled.button`
  border-radius: 2px;
  padding: 0.25em 1em;
  text-align: center;
  font-weight: bold;
  margin-bottom: 2em;
  min-width: 70%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: auto;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
`;

const ReadText = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1em;
  text-align: left;
`;
const Logo = withProps({ src: insured })(styled.img`
  height: inherit;
`);

const Head = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 1em 0.5em 0;
  }
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  text-transform: none;
  text-align: left;
  line-height: 1.5em;
`;

const Body = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 2em 0 0;
  }

  text-align: left;
  line-height: 1em;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
`;
const FlexData = styled(Flex)`
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
  }
`;
const BoxData = styled(Box)`
  flex-direction: column;
  padding-bottom: 0.75em;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    word-break: break-all;
    max-width: 90%;
    padding-bottom: 0.75em;
  }
`;
const BoxDate = styled(Box)`
  flex-direction: column;
  padding-bottom: 0.75em;
  white-space: nowrap;
  max-width: 90%;
  padding-bottom: 0.75em;
`;
const Insured = ({ info, back }) => {
  const { t } = useTranslation();
  const currentDate = moment().format("DD-MM-YYYY");
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <TextWrapper>
        <Title>{t("insuranceCheck.insured.title")}</Title>
        <Subtitle>{t("insuranceCheck.insured.subtitle", { currentDate })}</Subtitle>
        <DataWrapper>
          <FlexData align>
            <BoxData>
              <Head>{info.plate !== "" ? t("insuranceCheck.insured.license") : t("insuranceCheck.insured.vin")}</Head>
              <Body>{info.plate !== "" ? info.plate.toUpperCase() : info.VIN.toUpperCase()}</Body>
            </BoxData>
            <BoxDate>
              <Head>{t("insuranceCheck.insured.date")}</Head>
              <Body>{moment(info.date)?.format("DD-MM-YYYY")}</Body>
            </BoxDate>
            {info.makeName && (
              <BoxData>
                <Head>{t("insuranceCheck.insured.make")}</Head>
                <Body>{info?.makeName}</Body>
              </BoxData>
            )}
            {info.modelName && (
              <BoxData>
                <Head>{t("insuranceCheck.insured.model")}</Head>
                <Body>{info?.modelName}</Body>
              </BoxData>
            )}
          </FlexData>
        </DataWrapper>
        <BackButton onClick={back}>{t("common.backSearch")}</BackButton>
        <ReadText>{t("insuranceCheck.insured.info")}</ReadText>
      </TextWrapper>
    </Wrapper>
  );
};

export default Insured;
